import React, { useRef, useEffect } from "react";
import {
  Grid,
  Paper,
  makeStyles,
  useMediaQuery,
  useTheme,
  List,
  ListItemText,
  Button,
  CssBaseline,
  Typography,
  ListItemIcon,
  ListItem,
  AppBar
} from "@material-ui/core";

import backgroundImage from "./images/BG_Page_02.svg";
import agcLogo from "./images/SIP_template.png";
import sipAbacusLogo from "./images/sip-academy-logo1.png";
import plusLeft from "./images/plusSignLeft.svg";
import plusRight from "./images/plusSignRight.svg";

import agcDoll from "./images/DOLL_P2.svg";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import mobileBG from "./images/mobileBG.svg";
//import backgroundImage2022 from  "./images/BG_Page_2022.png"
import mobileBG2022 from "./images/Arithmetic_Genius_Contest_Mobile_BG.jpg";
import backgroundImage2022 from "./images/BG_2022_AGC.jpg";
import agc2023mobileLogo from "./images/Bg_2023_mobile.png";
import agc2023WebLogo from "./images/Bg_2023_web.png";
import agc2024mobileLogo from "./images/Bg_2024_mobile.png";
import agc2024WebLogo from "./images/Bg_2024_web.png";
import agc2025WebLogo from "./images/Plain_Background.png";
import title2025 from "./images/Title_Template.png";
import agc2025logo from "./images/AGC Logo 2025.png";
import studentImage from "./images/Student_Image.png";
import agc2025mobileLogo from "./images/Bg_2025_mobile.jpg";

const useStyles = makeStyles(theme => ({
  AGCRoot: {
    flexGrow: 1,
    alignContent: "stretch",
    wrap: "nowrap",
    overflow: "hidden",
    heigh: "100%"
  },
  paper: {
    width: "180%",
    height: "125vh",
    backgroundImage: `url(${agc2025WebLogo})`,
    overflow: "hidden",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover"
  },
  container: {
    textAlign: "center"
  },
  button: {
    color: "white",
    backgroundColor: "#E62127",
    fontWeight: "bold",
    borderRadius: theme.spacing(1),
    display: "inline-block",
    textAlign: "center"
  },
  titleDeskTop: {
    textAlign: "center",
    fontSize: theme.spacing(3),
    color: "white",
    backgroundColor: "#E62127",
    fontWeight: "bold",
    borderRadius: "20px",
    // height:"90%",
    padding: "3px"
    //height:theme.spacing(6)
  },
  titleMobile: {
    textAlign: "center",
    fontSize: theme.spacing(2),
    color: "white",
    backgroundColor: "#E62127",
    fontWeight: "bold",
    borderRadius: "20px",
    // height:"90%",
    padding: "3px"
    //height:theme.spacing(6)
  },
  mobilePaper: {
    height: "auto",
    backgroundImage: `url(${agc2025mobileLogo})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover"
  },
  registrationPageLink: {
    textDecoration: "none"
  },
  iconColor: {
    color: "yellow",
    fontSize: "75%"
  },
  text: {
    fontSize: "16px",
    fontWeight: "bold",
    color: "##000000"
  },
  title: {
    textAlign: "center",
    color: "white",
    backgroundColor: "#E62127",
    fontWeight: "bold",
    borderRadius: "15px",
    height: "85%",
    whiteSpace: "pre-line",
    display: "inline-block",
    fontSize: theme.spacing(2),
    padding: theme.spacing(3)
  }
}));

const AboutAGC = () => {
  const classes = useStyles();
  let theme = useTheme();
  const title = "Add excitement to Arithmetic";
  const register = "Sample Question Paper";
  const smallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  function Agc2021Content() {
    if (smallScreen) {
      //code for small screen
      return (
        <React.Fragment>
          <Grid container>
            <Grid item xs={12} sm={12}>
              <List>
                <ListItem>
                  <ListItemIcon>
                    <FiberManualRecordIcon className={classes.iconColor} />
                  </ListItemIcon>
                  <ListItemText>
                    <Typography className={classes.text}>
                      The ability to make friends with numbers is a crucial
                      skill that is vital for academic and career success.​
                    </Typography>
                  </ListItemText>
                </ListItem>

                <ListItem>
                  <ListItemIcon>
                    <FiberManualRecordIcon className={classes.iconColor} />
                  </ListItemIcon>
                  <ListItemText>
                    <Typography className={classes.text}>
                      Now in its 10th year,{" "}
                      <span style={{ fontWeight: "bold", color: "red" }}>
                        Arithmetic Genius Contest (AGC)
                      </span>{" "}
                      is not just a math contest – it’s a national platform that
                      helps children build strong foundational numeracy, boosts
                      their academic confidence, and offers them a chance to
                      shine.
                    </Typography>
                  </ListItemText>
                </ListItem>

                <ListItem>
                  <ListItemIcon>
                    <FiberManualRecordIcon className={classes.iconColor} />
                  </ListItemIcon>
                  <ListItemText>
                    <Typography className={classes.text}>
                      {" "}
                      &nbsp;&nbsp;&nbsp;AGC 2025 will be bigger, better, and
                      more exciting with participation from the best schools
                      across India and thousands of young minds competing to
                      become the next{" "}
                      <span style={{ fontWeight: "bold", color: "red" }}>
                        Arithmetic Genius.
                      </span>{" "}
                    </Typography>
                  </ListItemText>
                </ListItem>
              </List>
            </Grid>
            <Grid
              container
              xs={12}
              sm={12}
              justifyContent="flex-end"
              alignItems="flex-end"
            >
              {/*<img src={agcDoll} alt="doll" />*/}
            </Grid>
          </Grid>
        </React.Fragment>
      );
    } else {
      //code for large screen
      return (
        <React.Fragment>
          <Grid
            item
            container
            direction="row"
            style={{
              marginBottom: theme.spacing(7),
              marginTop: theme.spacing(7)
            }}
          >
            <Grid
              item
              container
              md={3}
              lg={3}
              justifyContent="flex-start"
              alignItems="flex-end"
            >
              {/* <img src={agcDoll} alt="doll" height={'200vh'} width={"300vw"} /> */}
            </Grid>

            <Grid item md={6} lg={6}>
              <List>
                <div>
                  <Typography className={classes.text}>
                    {" "}
                    &nbsp;&nbsp;&nbsp;&nbsp;The ability to make friends with
                    numbers is a crucial skill that is vital for academic and
                    career success.Now in its 10th year,{" "}
                    <span style={{ fontWeight: "bold", color: "red" }}>
                      Arithmetic Genius Contest (AGC)
                    </span>{" "}
                    is not just a math contest – it’s a national platform that
                    helps children build strong foundational numeracy, boosts
                    their academic confidence, and offers them a chance to
                    shine.
                  </Typography>
                </div>
                <br></br>
                <div>
                  <Typography className={classes.text}>
                    {" "}
                    &nbsp;&nbsp;&nbsp;AGC 2025 will be bigger, better, and more
                    exciting with participation from the best schools across
                    India and thousands of young minds competing to become the
                    next{" "}
                    <span style={{ fontWeight: "bold", color: "red" }}>
                      Arithmetic Genius.
                    </span>{" "}
                  </Typography>
                </div>
                <br></br>
                <br></br>
                <br></br>
                <br></br>
                <br></br>
                <br></br>
                <br></br>
                <br></br>
                <br></br>
              </List>
            </Grid>
            <Grid item md={3} lg={3}></Grid>
          </Grid>
        </React.Fragment>
      );
    }
  }

  return (
    <React.Fragment>
      <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="center"
      >
        <Paper className={smallScreen ? classes.mobilePaper : classes.paper}>
          <Grid container item md={12} xs={12}>
            <Grid item container md={12} xs={12} lg={12} sm={12}>
              <AppBar position="static" style={{ backgroundColor: "#E62127" }}>
                <Grid item md={3} xs={3} lg={3} sm={3}></Grid>
                <Grid item md={4} xs={9} sm={9} lg={4}>
                  <img
                    src={sipAbacusLogo}
                    alt="logo"
                    height={smallScreen ? "60%" : "60%"}
                    width={smallScreen ? "60%" : "50%"}
                  />
                </Grid>
                <Grid item md={5} xs={0} sm={0} lg={5}></Grid>
              </AppBar>
            </Grid>

            <Grid item container md={12} xs={12} lg={12} sm={12}>
              <Grid item xs={12}>
                <div
                  style={{
                    position: "relative",
                    width: "100vw",
                    height: "200px"
                  }}
                >
                  <img
                    src={agc2025logo}
                    style={{
                      position: "absolute",
                      top: smallScreen ? "30px" : "80px",
                      left: smallScreen ? "40px" : "150px",
                      width: smallScreen ? "80px" : "200px",
                      height: smallScreen ? "80px" : "200px",
                      zIndex: 2
                    }}
                  />
                  <img
                    src={agcLogo}
                    alt="Logo"
                    style={{
                      width: "100%",
                      height: smallScreen ? "80px" : "200px",
                      display: "block"
                    }}
                  />
                </div>
              </Grid>
              {!smallScreen && (
                <Grid item xs={12}>
                  <div
                    style={{
                      position: "relative",
                      bottom: "20px",
                      right: "20px",
                      zIndex: 2
                    }}
                  >
                    <img
                      src={studentImage}
                      alt="Student"
                      style={{
                        position: "absolute",
                        width: "400px",
                        height: "auto",
                        right: 0,
                        top: "350px"
                      }}
                    />
                  </div>
                </Grid>
              )}

              <Grid item md={6} xs={1} sm={1} lg={6}></Grid>

              <Grid item md={3} xs={6} sm={6} lg={3}>
                {smallScreen ? (
                  ""
                ) : (
                  <div>
                    <br></br>
                    <br></br>
                    <br></br> <br></br>
                    <br></br>{" "}
                  </div>
                )}

                <Grid container style={{ marginTop: theme.spacing(3) }}>
                  <Grid item container style={{ marginTop: theme.spacing(3) }}>
                  <Grid
                    item
                    md={3}
                    xs={2}
                    sm={2}
                    lg={3}
                    alignContent="flex-end"
                  ></Grid>

                  <Grid item md={6} xs={8} sm={8} lg={6}>
                    <div style={{ position: "relative", width: "100%", height: "100px" }}>
    <a
      href="#sampleQuestionPaper"
      className={classes.registrationPageLink}
    >
      <Button
        style={{
          position: 'absolute',
          top: smallScreen ? "-140px" : "400px", 
          left: smallScreen ? "180px" : "-200px",
          width: "100%",
          fontSize: smallScreen ? "10px" : "14px",
          zIndex: 10,
        }}
        variant="contained"
        className={classes.button}
      >
        {register}
      </Button>
    </a>
  </div>
                  </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid
              item
              md={12}
              xs={12}
              lg={12}
              sm={12}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginTop: smallScreen ? theme.spacing(1) : "2%",
                position: "relative"
              }}
            >
              <img
                src={title2025}
                alt="Title Template"
                style={{
                  width: smallScreen ? "90vw" : "600px",
                  height: smallScreen ? "70px" : "100px",
                  position: "absolute",
                  top: smallScreen ? "-140px" : "-160px"
                }}
              />

              <Typography
                style={{
             position: "absolute",
             color: "white",
             fontWeight: "bold",
             fontSize: smallScreen ? "16px" : "28px",
             textAlign: "center",
             width: "80%",
             top: "-110px",
             transform: "translateY(-50%)",
            }}
              >
                {title}
              </Typography>
            </Grid>

            <Grid
              item
              container
              md={12}
              xs={12}
              lg={12}
              sm={12}
              style={{
                marginTop: smallScreen ? -theme.spacing(6) : -theme.spacing(0)
              }}
            >
              {/* call the fragment */}
              <Agc2021Content></Agc2021Content>
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    </React.Fragment>
  );
};

export default AboutAGC;
